import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import React from 'react';
import { groupData } from './common';

export function extractPressData(list) {
  const sortKeysHashMap = {
    origin: 'origin',
    date: 'originalDate'
  };

  const newList = list.map((item) => {
    const momentDate = moment(item.pubdate);
    const dateString = momentDate.format('DD/MM/YYYY');
    const description = `${item.title} ${I18n.t(
      'dashboard.feedDescriptions.by'
    )} ${item.source_name}`;
    return {
      post_id: item.post_id,
      link: getPressLink(item),
      type: 'press',
      order: 4,
      title: I18n.t('dashboard.feedTitles.press'),
      is_paper: item.is_paper,
      origin: item.category_name,
      originalDate: dateString,
      date: dateString,
      momentDate,
      description
    };
  });

  const sameFunc = (acc, curr) => {
    const previous = acc[acc.length - 1];
    previous.descriptionList.push(curr.description);
    acc[acc.length - 1] = previous;
    return acc;
  };

  const diffFunc = (acc, curr) => {
    const descriptionList = (
      <React.Fragment>
        <a href={getPressLink(curr)}>{curr.description}</a>
      </React.Fragment>
    );
    acc.push({
      ...curr,
      descriptionList: [descriptionList]
    });
    return acc;
  };

  return groupData(newList, sortKeysHashMap, sameFunc, diffFunc);
}

function getPressLink(item) {
  if (item.post_id) {
    return `/communication/media/article/${item.post_id}/`;
  }
  return '/communication/media';
}
